import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableProps } from 'rsuite/lib/Table';
import { RootState } from '../../@types/RootState';

export type GetFamilyClusterModalPaginationStateSortState<K extends TableProps['sortColumn'] = string> = {
  type: K;
  orderBy: TableProps['sortType'];
};

const initialState: GetFamilyClusterModalPaginationStateSortState = {
  type: 'productIds',
  orderBy: 'asc',
};

const slice = createSlice({
  name: 'getFamilyClusterModal/sort',
  initialState,
  reducers: {
    SET_GET_FAMILY_CLUSTER_MODAL_SORT: (_state, { payload }: PayloadAction<GetFamilyClusterModalPaginationStateSortState>) => payload,
  },
});

export const { SET_GET_FAMILY_CLUSTER_MODAL_SORT } = slice.actions;

export const selectorGetFamilyClusterModalSort = (state: RootState) => {
  return state.getFamilyClusterModalReducer.sort;
};

export default slice.reducer;
